import { useState } from "react";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import ServiceSection from "./components/ServiceSection";

const servicesData = [
  {
    id: "hair",
    titleEn: "Hair Services",
    titleAr: "خدمات الشعر",
    subtitleAr: "تصفيف، صبغ، علاجات وإضافات الشعر",
    descEn:
      "Transform your look with our professional hair services, from stylish cuts to advanced treatments. Our experienced hairstylists are skilled in creating the perfect hairstyle for every occasion. Whether you're looking for a chic haircut or need expert coloring services, we are here to help you achieve the perfect look.",
    descAr:
      "حوّلي إطلالتك مع خدمات الشعر الاحترافية لدينا، من القصات العصرية إلى العلاجات المتقدمة. مصففو شعرنا ذوو خبرة في ابتكار التسريحة المثالية لكل مناسبة. سواء كنتِ تبحثين عن قصة أنيقة أو خدمات صبغ احترافية، نحن هنا لمساعدتك.",
    listTitleEn: "Our Hair Services Include:",
    listTitleAr: "تشمل خدمات الشعر لدينا:",
    items: [
      { en: "Haircuts & Styling: Trendy cuts and expert styling to suit your personal style.", ar: "قص الشعر والتصفيف: قصات عصرية وتصفيف احترافي يناسب أسلوبك الشخصي." },
      { en: "Hair Coloring & Highlights: Professional coloring techniques for stunning, vibrant shades.", ar: "صبغ الشعر والهايلايت: تقنيات صبغ احترافية لألوان مذهلة وحيوية." },
      { en: "Hair Treatments: Nourishing treatments like Keratin and Olaplex for smooth, healthy hair.", ar: "علاجات الشعر: علاجات مغذية مثل الكيراتين والأوليبليكس للشعر الناعم والصحي." },
      { en: "Hair Extensions: High-quality extensions to add length and volume to your hair.", ar: "وصلات الشعر: وصلات عالية الجودة لإضافة الطول والحجم لشعرك." },
    ],
    image:
      "https://public.readdy.ai/ai/img_res/8a284a4c1b6c6877facf7551391f4032.jpg",
    imageAlt: "Hair Services - Blue Moon Beauty Salon Al Koudh Muscat Oman",
    reverse: false,
    icon: "ri-scissors-line",
  },
  {
    id: "nails",
    titleEn: "Nail Services",
    titleAr: "خدمات الأظافر",
    subtitleAr: "مانيكير، باديكير، جل، اكريليك وفنون الأظافر",
    descEn:
      "Indulge in luxury nail treatments at our salon, where our skilled nail technicians create beautiful nails to match your style. Whether you prefer a classic manicure or want something more artistic, our nail services ensure your hands and feet are perfectly pampered.",
    descAr:
      "استمتعي بعلاجات الأظافر الفاخرة في صالوننا، حيث يبتكر فنيو الأظافر المهرة لدينا أظافراً جميلة تناسب أسلوبك. سواء كنتِ تفضلين المانيكير الكلاسيكي أو شيئاً فنياً أكثر، خدمات أظافرنا تضمن للإيديين والقدمين العناية المثالية.",
    listTitleEn: "Our Nail Services Include:",
    listTitleAr: "تشمل خدمات الأظافر لدينا:",
    items: [
      { en: "Manicure & Pedicure: Classic or gel treatments for smooth, polished nails.", ar: "مانيكير وباديكير: علاجات كلاسيكية أو جل للأظافر الناعمة واللامعة." },
      { en: "Gel Nails: Long-lasting gel nails for a durable, glossy finish.", ar: "أظافر الجل: أظافر جل طويلة الأمد لمظهر لامع ومتين." },
      { en: "Nail Extensions & Acrylics: Add length and strength to your nails with expert applications.", ar: "تمديد الأظافر والأكريليك: أضيفي الطول والقوة لأظافرك مع تطبيقات احترافية." },
      { en: "Nail Art & Design: Creative, custom designs that express your individuality.", ar: "فنون الأظافر والتصاميم: تصاميم مبتكرة ومخصصة تعبّر عن شخصيتك." },
    ],
    image:
      "https://readdy.ai/api/search-image?query=luxury%20nail%20art%20manicure%20close%20up%2C%20elegant%20woman%20hands%20with%20beautiful%20nail%20design%2C%20gold%20and%20nude%20tones%2C%20professional%20nail%20salon%20treatment%2C%20high-end%20beauty&width=600&height=400&seq=bm_svc002&orientation=landscape",
    imageAlt: "Nail Services - Blue Moon Beauty Salon Muscat Oman",
    reverse: true,
    icon: "ri-hand-coin-line",
  },
  {
    id: "facials",
    titleEn: "Facial & Skincare Treatments",
    titleAr: "علاجات الوجه والبشرة",
    subtitleAr: "جلسات ترطيب، مكافحة الشيخوخة وتنظيف عميق",
    descEn:
      "Refresh and rejuvenate your skin with our specialized facial and skincare treatments. Our experienced estheticians use high-quality products tailored to your skin type, ensuring a glowing complexion after every visit.",
    descAr:
      "جدّدي بشرتك وانتعشيها مع علاجات الوجه والبشرة المتخصصة لدينا. يستخدم خبراء التجميل المتمرسون لدينا منتجات عالية الجودة مصممة لنوع بشرتك، لضمان وجه مشرق ومتوهج بعد كل زيارة.",
    listTitleEn: "Our Skincare Services Include:",
    listTitleAr: "تشمل خدمات العناية بالبشرة لدينا:",
    items: [
      { en: "Hydrating Facial: Moisturize and restore your skin's natural glow.", ar: "جلسة الترطيب: رطّبي بشرتك واستعيدي توهجها الطبيعي." },
      { en: "Anti-Aging Facial: Combat the signs of aging with our targeted treatments.", ar: "جلسة مكافحة الشيخوخة: تصدّي لعلامات التقدم في السن بعلاجاتنا المستهدفة." },
      { en: "Deep Cleansing Facial: Clear out impurities for a fresh, healthy complexion.", ar: "التنظيف العميق: تخلّصي من الشوائب للحصول على بشرة نضرة وصحية." },
      { en: "Acne Treatment: Customized treatments to target acne and blemishes.", ar: "علاج حب الشباب: علاجات مخصصة للتعامل مع حب الشباب والبقع." },
    ],
    image:
      "https://readdy.ai/api/search-image?query=luxury%20facial%20treatment%20spa%2C%20woman%20receiving%20gold%20facial%20mask%20beauty%20treatment%2C%20relaxing%20spa%20environment%2C%20glowing%20radiant%20skin%2C%20professional%20aesthetician%2C%20warm%20candlelight&width=600&height=400&seq=bm_svc003&orientation=landscape",
    imageAlt: "Facial & Skincare Treatments - Blue Moon Beauty Salon Muscat",
    reverse: false,
    icon: "ri-sparkling-2-line",
  },
  {
    id: "massage",
    titleEn: "Massage Services",
    titleAr: "خدمات المساج",
    subtitleAr: "استرخاء، تخفيف الإجهاد وعلاجات جسدية فاخرة",
    descEn:
      "Relax and unwind with our range of luxurious massages. Our experienced therapists provide soothing and therapeutic massages to help relieve stress, tension, and fatigue.",
    descAr:
      "استرخي واسترحي مع مجموعتنا من المساجات الفاخرة. يقدم معالجونا المتمرسون مساجات مهدئة وعلاجية تساعد على تخفيف التوتر والإجهاد والإرهاق.",
    listTitleEn: "Our Massage Services Include:",
    listTitleAr: "تشمل خدمات المساج لدينا:",
    items: [
      { en: "Swedish Massage: Gentle relaxation massage to relieve stress and enhance circulation.", ar: "المساج السويدي: مساج استرخاء لطيف لتخفيف التوتر وتعزيز الدورة الدموية." },
      { en: "Deep Tissue Massage: Targeted massage therapy for deeper muscle relief.", ar: "مساج الأنسجة العميقة: علاج مساج موجّه للارتياح العضلي العميق." },
      { en: "Hot Stone Massage: Warm stones to release tension and promote healing.", ar: "مساج الحجر الساخن: أحجار دافئة لإطلاق التوتر وتعزيز الشفاء." },
      { en: "Aromatherapy Massage: Essential oils combined with massage to relax both body and mind.", ar: "مساج العلاج بالروائح: زيوت أساسية مع المساج لإرخاء الجسم والعقل." },
    ],
    image:
      "https://readdy.ai/api/search-image?query=luxury%20spa%20massage%20treatment%2C%20woman%20relaxing%20during%20hot%20stone%20massage%20therapy%2C%20serene%20spa%20environment%2C%20candles%20and%20flowers%2C%20high-end%20wellness%20experience%20oman%20spa&width=600&height=400&seq=bm_svc005&orientation=landscape",
    imageAlt: "Massage Services - Blue Moon Beauty Salon & Spa Muscat Oman",
    reverse: true,
    icon: "ri-hand-heart-line",
  },
  {
    id: "waxing",
    titleEn: "Waxing & Threading",
    titleAr: "إزالة الشعر بالشمع والخيط",
    subtitleAr: "بشرة ناعمة وخالية من الشعر بأيدٍ خبيرة",
    descEn:
      "For smooth, hair-free skin, we offer gentle and effective waxing and threading services. Our team uses high-quality products to ensure minimal discomfort and long-lasting results.",
    descAr:
      "للحصول على بشرة ناعمة وخالية من الشعر، نقدم خدمات إزالة الشعر بالشمع والخيط بطريقة لطيفة وفعّالة. يستخدم فريقنا منتجات عالية الجودة لضمان أقل قدر من الانزعاج ونتائج طويلة الأمد.",
    listTitleEn: "Our Waxing & Threading Services Include:",
    listTitleAr: "تشمل خدمات إزالة الشعر لدينا:",
    items: [
      { en: "Full Body Waxing: Smooth, hair-free skin from head to toe.", ar: "إزالة شعر الجسم الكامل: بشرة ناعمة وخالية من الشعر من الرأس إلى القدمين." },
      { en: "Eyebrow Threading: Perfectly shaped brows to frame your face.", ar: "تحديد الحواجب بالخيط: حواجب منسقة بشكل مثالي لإطار وجهك." },
      { en: "Bikini & Brazilian Waxing: Expert waxing for sensitive areas.", ar: "إزالة شعر البيكيني والبرازيلي: إزالة احترافية للمناطق الحساسة." },
      { en: "Underarm Waxing: Clean, smooth underarms with gentle waxing.", ar: "إزالة شعر الإبط: إبط نظيف وناعم بإزالة لطيفة بالشمع." },
    ],
    image:
      "https://readdy.ai/api/search-image?query=professional%20eyelash%20extension%20treatment%20close%20up%2C%20beautiful%20eyes%20with%20long%20lush%20perfect%20lashes%2C%20luxury%20beauty%20salon%2C%20precision%20lash%20artistry%2C%20warm%20soft%20background&width=600&height=400&seq=bm_svc004&orientation=landscape",
    imageAlt: "Waxing & Threading Services - Blue Moon Beauty Salon Muscat Oman",
    reverse: false,
    icon: "ri-magic-line",
  },
  {
    id: "makeup",
    titleEn: "Makeup Services",
    titleAr: "خدمات المكياج",
    subtitleAr: "مكياج العرائس، الحفلات والمناسبات الخاصة",
    descEn:
      "Look your best for any occasion with our professional makeup services. Whether it's your wedding day or a night out, our makeup artists create stunning looks that enhance your natural beauty.",
    descAr:
      "تألّقي في أي مناسبة مع خدمات المكياج الاحترافية لدينا. سواء كان يوم زفافك أو ليلة خارجة، يبتكر فنانو المكياج لدينا إطلالات رائعة تبرز جمالك الطبيعي.",
    listTitleEn: "Our Makeup Services Include:",
    listTitleAr: "تشمل خدمات المكياج لدينا:",
    items: [
      { en: "Bridal Makeup: Flawless makeup for your big day.", ar: "مكياج العرائس: مكياج لا تشوبه شائبة ليوم زفافك الكبير." },
      { en: "Party Makeup: Glamorous looks for special events.", ar: "مكياج الحفلات: إطلالات ساحرة للمناسبات الخاصة." },
      { en: "Evening Makeup: Elegant and sophisticated makeup for formal occasions.", ar: "مكياج السهرة: مكياج أنيق وراقٍ للمناسبات الرسمية." },
      { en: "Event Makeup: Professional makeup for all types of occasions.", ar: "مكياج الفعاليات: مكياج احترافي لجميع أنواع المناسبات." },
    ],
    image:
      "https://readdy.ai/api/search-image?query=luxury%20body%20treatment%20scrub%20wrap%20spa%2C%20woman%20in%20towel%20receiving%20body%20care%20treatment%2C%20clean%20modern%20spa%20room%2C%20soft%20warm%20golden%20lighting%2C%20rejuvenating%20beauty%20experience&width=600&height=400&seq=bm_svc006&orientation=landscape",
    imageAlt: "Makeup Services - Blue Moon Beauty Salon Muscat Oman",
    reverse: true,
    icon: "ri-brush-line",
  },
  {
    id: "moroccan-bath",
    titleEn: "Moroccan Bath",
    titleAr: "الحمام المغربي",
    subtitleAr: "تنظيف عميق وتقشير فاخر للجسم بالتقنية المغربية الأصيلة",
    descEn:
      "Immerse yourself in the ancient luxury of an authentic Moroccan Bath — a centuries-old ritual that deeply cleanses, exfoliates, and revitalizes your skin from head to toe. Using traditional black soap, kessa glove, and rich ghassoul clay, this indulgent treatment leaves your skin incredibly soft, radiant, and deeply nourished.",
    descAr:
      "انغمسي في رفاهية الحمام المغربي الأصيل — طقس عريق يعمل على تنظيف البشرة بعمق وتقشيرها وتجديد حيويتها من الرأس إلى أخمص القدمين. باستخدام الصابون البلدي الأسود وكيس الكيسة وطين الغاسول الغني، يمنح هذا العلاج الرائع بشرتك نعومة لا مثيل لها وإشراقاً وتغذية عميقة.",
    listTitleEn: "Our Moroccan Bath Includes:",
    listTitleAr: "يشمل حمامنا المغربي:",
    items: [
      { en: "Black Soap Cleanse: Traditional Beldi black soap to deeply purify and soften the skin.", ar: "تنظيف بالصابون الأسود: الصابون البلدي المغربي الأصيل لتنقية البشرة وترطيبها بعمق." },
      { en: "Kessa Exfoliation: Expert full-body scrub using the traditional kessa glove to remove dead skin.", ar: "تقشير بالكيسة: تقشير كامل للجسم بكيسة التقشير التقليدية لإزالة الخلايا الميتة." },
      { en: "Ghassoul Clay Mask: Mineral-rich clay mask to purify pores and restore the skin\'s natural balance.", ar: "ماسك الغاسول: ماسك الطين الغني بالمعادن لتنقية المسام واستعادة توازن البشرة الطبيعي." },
      { en: "Argan Oil Hydration: Luxurious Moroccan argan oil application for deep moisture and a lasting glow.", ar: "ترطيب بزيت الأرغان: تطبيق فاخر لزيت الأرغان المغربي لترطيب عميق وإشراق استثنائي." },
    ],
    image: "https://public.readdy.ai/ai/img_res/edited_51f145a4c3f6429ee79798d0cea89a42_d28c4bee.jpg",
    imageAlt: "Moroccan Bath - Blue Moon Beauty Salon & Spa Muscat Oman",
    reverse: false,
    icon: "ri-drop-line",
  },
  {
    id: "eyelashes-eyebrows",
    titleEn: "Eyelashes & Eyebrows",
    titleAr: "الرموش والحواجب",
    subtitleAr: "تصميم وتكثيف الرموش وتشكيل الحواجب بدقة متناهية",
    descEn:
      "Frame your face beautifully with our expert eyelash and eyebrow services. From lush lash extensions to perfectly sculpted brows, our skilled technicians use premium techniques and materials to give your eyes a stunning, defined look that lasts.",
    descAr:
      "أطلقي جمال عيونك مع خدمات الرموش والحواجب الاحترافية لدينا. من وصلات الرموش الكثيفة إلى الحواجب المشكّلة بإتقان، يستخدم فنيونا المهرة تقنيات ومواد فاخرة لمنح عيونك مظهراً ساحراً ومحدداً يدوم طويلاً.",
    listTitleEn: "Our Lash & Brow Services Include:",
    listTitleAr: "تشمل خدمات الرموش والحواجب لدينا:",
    items: [
      { en: "Lash Extensions: Classic, volume, or mega volume extensions for full, dramatic lashes.", ar: "وصلات الرموش: وصلات كلاسيكية أو حجمية أو فائقة الحجم لرموش كثيفة ومذهلة." },
      { en: "Lash Lift & Tint: Curl and darken your natural lashes for an effortlessly wide-eyed look.", ar: "رفع وصبغ الرموش: تجعيد وتغميق الرموش الطبيعية للحصول على مظهر مفتوح ساحر." },
      { en: "Eyebrow Threading & Shaping: Precise threading to sculpt perfectly symmetrical brows.", ar: "تحديد وتشكيل الحواجب بالخيط: خيط دقيق لتشكيل حواجب متناسقة ومثالية." },
      { en: "Eyebrow Tinting & Lamination: Fuller, bolder brows with professional tinting and lamination.", ar: "صبغ ولاميناتيون الحواجب: حواجب أكثر امتلاءً وجرأة بصبغ ولاميناتيون احترافي." },
    ],
    image: "https://public.readdy.ai/ai/img_res/edited_f122a6a3c28b3bd8ef2c500f367fbe40_f8130a69.jpg",
    imageAlt: "Eyelashes & Eyebrows - Blue Moon Beauty Salon Muscat Oman",
    reverse: true,
    icon: "ri-eye-line",
  },
];

const faqs = [
  {
    q: "How do I book an appointment for your services?",
    qAr: "كيف أحجز موعداً لخدماتكم؟",
    a: "You can easily book an appointment by sending us a WhatsApp message at +968 92102051 or calling us directly. We recommend booking in advance to secure your preferred time slot.",
    aAr: "يمكنك بسهولة حجز موعد عبر إرسال رسالة واتساب على +968 92102051 أو الاتصال بنا مباشرة. نوصي بالحجز مسبقاً لضمان الوقت المفضل لديك.",
  },
  {
    q: "Do you offer consultations for hair and skincare services?",
    qAr: "هل تقدمون استشارات لخدمات الشعر والعناية بالبشرة؟",
    a: "Yes, we offer free consultations for our hair and skincare services. Our beauticians will assess your needs, recommend the right treatments, and answer any questions you may have.",
    aAr: "نعم، نقدم استشارات مجانية لخدمات الشعر والعناية بالبشرة. سيقيّم خبراء التجميل لدينا احتياجاتك ويوصون بالعلاجات المناسبة ويجيبون على أي أسئلة لديك.",
  },
  {
    q: "What safety and hygiene measures do you follow?",
    qAr: "ما هي معايير السلامة والنظافة التي تتبعونها؟",
    a: "We prioritize hygiene and cleanliness in all our services. Our tools and equipment are sanitized after every use, and we follow strict hygiene protocols for waxing, threading, and all other treatments.",
    aAr: "نولي الصحة والنظافة الأولوية في جميع خدماتنا. يتم تعقيم أدواتنا ومعداتنا بعد كل استخدام، ونتبع بروتوكولات نظافة صارمة لجميع العلاجات.",
  },
  {
    q: "Can I walk in for an appointment, or do I need to book in advance?",
    qAr: "هل يمكنني الحضور مباشرة أم يجب الحجز المسبق؟",
    a: "While we welcome walk-ins, we highly recommend booking your appointment in advance to ensure availability, especially during peak hours.",
    aAr: "بينما نرحب بالزيارات المباشرة، نوصي بشدة بحجز موعدك مسبقاً لضمان التوفر، خاصة خلال أوقات الذروة.",
  },
  {
    q: "Do you have loyalty programs or special offers for regular clients?",
    qAr: "هل لديكم برامج ولاء أو عروض خاصة للعملاء المنتظمين؟",
    a: "Yes, we offer special promotions for our regular clients. Contact us on WhatsApp at +968 92102051 or follow us on Instagram to stay updated on our latest offers.",
    aAr: "نعم، نقدم عروضاً خاصة للعملاء المنتظمين. تواصلي معنا عبر واتساب +968 92102051 أو تابعينا على إنستغرام للاطلاع على آخر عروضنا.",
  },
];

function FAQItem({ q, qAr, a, aAr }: { q: string; qAr: string; a: string; aAr: string }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-[#ece8e0]">
      <button
        className="w-full flex justify-between items-start gap-4 py-5 text-left cursor-pointer hover:text-[#c6a864] transition-colors"
        onClick={() => setOpen(!open)}
      >
        <div className="flex-1">
          <p className="text-[#1a2744] text-sm font-medium">{q}</p>
          <p className="text-[#1a2744]/60 text-sm mt-0.5 text-right" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>{qAr}</p>
        </div>
        <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
          <i className={`${open ? "ri-subtract-line" : "ri-add-line"} text-[#c6a864] text-lg`}></i>
        </div>
      </button>
      {open && (
        <div className="pb-5 pl-2">
          <p className="text-gray-500 text-sm leading-relaxed mb-2">{a}</p>
          <p className="text-gray-400 text-sm leading-relaxed text-right" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>{aAr}</p>
        </div>
      )}
    </div>
  );
}

const whyUs = [
  { icon: "ri-user-star-line", en: "Expert Beauticians", ar: "خبراء متخصصون", desc: "Highly trained professionals with years of experience.", descAr: "متخصصون مدرّبون بسنوات من الخبرة." },
  { icon: "ri-moon-line", en: "Relaxing Atmosphere", ar: "أجواء هادئة", desc: "A calm, luxurious environment designed for your comfort.", descAr: "بيئة هادئة وفاخرة مصممة لراحتك." },
  { icon: "ri-magic-line", en: "Tailored Services", ar: "خدمات مخصصة", desc: "We personalize every service to suit your unique needs.", descAr: "نخصص كل خدمة لتناسب احتياجاتك الفريدة." },
  { icon: "ri-award-line", en: "Premium Products", ar: "منتجات فاخرة", desc: "We use only the best products for hair, skin, and nails.", descAr: "نستخدم فقط أفضل المنتجات للشعر والبشرة والأظافر." },
];

export default function ServicesPage() {
  return (
    <div className="w-full overflow-x-hidden">
      <Navbar />

      {/* Page Header — Image Background + Frosted Glass */}
      <div className="relative w-full pt-24 sm:pt-28 pb-14 sm:pb-20 overflow-hidden">
        {/* Background image */}
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=opulent%20luxury%20beauty%20spa%20interior%20with%20gold%20accents%2C%20marble%20surfaces%2C%20soft%20warm%20candle%20lighting%2C%20rose%20petals%20and%20flowers%2C%20elegant%20cosmetics%20arrangement%2C%20dreamy%20bokeh%20background%2C%20rich%20navy%20and%20gold%20tones%2C%20high-end%20salon%20ambiance&width=1440&height=700&seq=bm_svchero_v2&orientation=landscape"
            alt="Blue Moon Beauty Salon Services Banner Al Koudh Muscat Oman"
            className="w-full h-full object-cover object-top"
            loading="eager"
          />
          {/* Dark gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-b from-[#1a2744]/40 via-[#1a2744]/25 to-[#1a2744]/50"></div>
          {/* Subtle texture overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-black/10 via-transparent to-black/10"></div>
        </div>

        {/* Frosted glass content card */}
        <div className="relative z-10 max-w-3xl mx-auto px-4 sm:px-6">
          <div
            className="rounded-sm px-6 sm:px-10 py-8 sm:py-12 text-center"
            style={{
              background: "rgba(255,255,255,0.07)",
              backdropFilter: "blur(14px)",
              WebkitBackdropFilter: "blur(14px)",
              border: "1px solid rgba(198,168,100,0.25)",
              boxShadow: "0 8px 40px rgba(0,0,0,0.25)",
            }}
          >
            {/* Moon icon */}
            <div className="w-10 h-10 flex items-center justify-center mx-auto mb-4 border border-[#c6a864]/60"
              style={{ background: "rgba(198,168,100,0.12)" }}>
              <i className="ri-moon-line text-[#c6a864] text-xl"></i>
            </div>

            <p className="text-[#c6a864] text-xs tracking-[0.4em] uppercase mb-3 font-light">
              Blue Moon Beauty Salon &amp; Spa — Al Koudh, Muscat
            </p>

            <h1
              className="text-white text-3xl sm:text-5xl font-light tracking-wide mb-2"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Our Services
            </h1>
            <p
              className="text-[#c6a864] text-2xl sm:text-3xl font-bold mb-3"
              style={{ fontFamily: "'Noto Naskh Arabic', serif", direction: "rtl" }}
            >
              خدماتنا الجمالية
            </p>

            {/* Gold divider */}
            <div className="w-16 h-px bg-[#c6a864]/50 mx-auto mb-4"></div>

            <p className="text-white/70 text-sm leading-relaxed max-w-xl mx-auto mb-2">
              Welcome to Blue Moon Beauty Salon &amp; Spa, your trusted beauty destination in Al Koudh, Muscat. We offer a wide range of premium beauty services tailored to your every need.
            </p>
            <p
              className="text-white/55 text-sm leading-relaxed mb-7"
              style={{ fontFamily: "'Noto Naskh Arabic', serif", direction: "rtl" }}
            >
              مرحباً بك في صالون وسبا القمر الأزرق، وجهتك الموثوقة للتجميل في الخوض، مسقط.
            </p>

            {/* Service Nav Pills */}
            <div className="flex flex-wrap justify-center gap-2">
              {servicesData.map((s) => (
                <a
                  key={s.id}
                  href={`#${s.id}`}
                  className="flex items-center gap-1.5 text-white text-xs px-3 py-1.5 transition-all duration-200 cursor-pointer whitespace-nowrap hover:text-[#c6a864]"
                  style={{
                    background: "rgba(255,255,255,0.1)",
                    backdropFilter: "blur(6px)",
                    border: "1px solid rgba(255,255,255,0.18)",
                  }}
                  onMouseEnter={(e) => {
                    (e.currentTarget as HTMLAnchorElement).style.background = "rgba(198,168,100,0.25)";
                    (e.currentTarget as HTMLAnchorElement).style.borderColor = "rgba(198,168,100,0.6)";
                  }}
                  onMouseLeave={(e) => {
                    (e.currentTarget as HTMLAnchorElement).style.background = "rgba(255,255,255,0.1)";
                    (e.currentTarget as HTMLAnchorElement).style.borderColor = "rgba(255,255,255,0.18)";
                  }}
                >
                  <i className={`${s.icon} text-sm`}></i>
                  <span>{s.titleEn}</span>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Decorative bottom fade */}
        <div className="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-white to-transparent"></div>
      </div>

      {/* Services Sections */}
      <div className="bg-white">
        {servicesData.map((svc) => (
          <ServiceSection key={svc.id} {...svc} />
        ))}
      </div>

      {/* Why Choose Us */}
      <section className="py-14 sm:py-20 bg-[#f8f7f4]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10 sm:mb-14">
            <p className="text-[#4a7fa5] text-xs tracking-[0.4em] uppercase mb-3 font-light">Our Promise</p>
            <h2 className="text-[#1a2744] text-2xl sm:text-3xl font-light" style={{ fontFamily: "'Playfair Display', serif" }}>
              Why Choose Blue Moon Beauty?
            </h2>
            <p className="text-[#1a2744] text-xl font-bold mt-1" style={{ fontFamily: "'Noto Naskh Arabic', serif", direction: "rtl" }}>
              لماذا تختارين صالون القمر الأزرق؟
            </p>
            <p className="text-gray-400 text-sm mt-3 max-w-xl mx-auto">
              At Blue Moon Beauty Salon, we believe beauty is more than just skin deep. We focus on delivering exceptional service, using top-quality products, and providing personalized care to each client in Al Koudh, Muscat.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
            {whyUs.map((item) => (
              <div key={item.en} className="bg-white p-6 text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 border border-[#ece8e0]">
                  <i className={`${item.icon} text-[#c6a864] text-2xl`}></i>
                </div>
                <h3 className="text-[#1a2744] text-sm font-semibold mb-0.5">{item.en}</h3>
                <p className="text-[#c6a864] text-sm font-medium mb-2" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>{item.ar}</p>
                <p className="text-gray-400 text-xs leading-relaxed">{item.desc}</p>
                <p className="text-gray-300 text-xs leading-relaxed mt-1" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>{item.descAr}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-14 sm:py-20 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10">
            <p className="text-[#4a7fa5] text-xs tracking-[0.4em] uppercase mb-3 font-light">FAQ</p>
            <h2 className="text-[#1a2744] text-2xl sm:text-3xl font-light" style={{ fontFamily: "'Playfair Display', serif" }}>
              Frequently Asked Questions
            </h2>
            <p className="text-[#1a2744] text-xl font-bold mt-1" style={{ fontFamily: "'Noto Naskh Arabic', serif", direction: "rtl" }}>
              الأسئلة الشائعة
            </p>
          </div>
          <div>
            {faqs.map((faq, i) => (
              <FAQItem key={i} {...faq} />
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-14 sm:py-20 bg-[#1a2744] text-center">
        <div className="max-w-2xl mx-auto px-4 sm:px-6">
          <div className="w-10 h-10 flex items-center justify-center mx-auto mb-4 border border-[#c6a864]/40">
            <i className="ri-moon-line text-[#c6a864] text-xl"></i>
          </div>
          <h2 className="text-white text-2xl sm:text-3xl font-light mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
            Ready for a Beauty Transformation?
          </h2>
          <p className="text-[#c6a864] text-xl font-bold mb-4" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>
            هل أنتِ مستعدة لتحول جمالي؟
          </p>
          <p className="text-white/60 text-sm mb-2">
            Whether you&apos;re looking to refresh your look or indulge in a day of pampering, we&apos;re here to make it happen. Book your appointment now at Blue Moon Beauty Salon, Al Koudh, Muscat.
          </p>
          <p className="text-white/50 text-sm mb-8" style={{ fontFamily: "'Noto Naskh Arabic', serif", direction: "rtl" }}>
            سواء كنتِ تبحثين عن تجديد إطلالتك أو الاسترخاء التام، نحن هنا لتحقيق ذلك. احجزي موعدك الآن في صالون القمر الأزرق، الخوض، مسقط.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://api.whatsapp.com/send?phone=96892102051&text=Hello%20Blue%20Moon%20Beauty%20Salon%20%26%20Spa%2C%20I%20would%20like%20more%20information%20about%20your%20services."
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer bg-[#25D366] text-white text-xs tracking-[0.2em] uppercase px-8 py-4 hover:bg-[#20ba5a] transition-colors duration-300"
            >
              <i className="ri-whatsapp-line text-base"></i>
              <span>Book via WhatsApp</span>
              <span style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>— احجزي الآن</span>
            </a>
            <a
              href="tel:+96892102051"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer border border-white/40 text-white text-xs tracking-[0.2em] uppercase px-8 py-4 hover:border-[#c6a864] hover:text-[#c6a864] transition-colors duration-300"
            >
              <i className="ri-phone-line text-base"></i>
              +968 92102051
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
